import HTTP from "@/http";

export function getSheZhi(params = {}) {
  return HTTP({
    url: "api/shezhi",
    method: "GET",
    params,
  });
}
